<template>
  <core-section id="contact" class="mt-7">

    <v-card class="mx-auto " color="secondary">
      <v-card-text>
        <v-col cols="auto">
          <v-btn x-large color="primary" href="https://github.com/jankowski-app" target="_blank">
            <v-icon class="ma-0">mdi-github</v-icon>GitHub
          </v-btn>
        </v-col>
      </v-card-text>
    </v-card>

    <core-heading>{{ $t('contact.title') }}</core-heading>

    <v-col cols="12" md="5" class="mb-4 pr-md-5">
      <core-subheading class="text-uppercase mb-3">
        {{ $t('contact.description') }}
      </core-subheading>

      <form>
        <v-text-field
            v-model="form.email"
            :error-messages="emailErrors"
            :label="$t('contact.label-email')"
            required
            @input="$v.form.email.$touch()"
            @blur="$v.form.email.$touch()"
            solo
            flat
        ></v-text-field>
        <v-textarea
            v-model="form.message"
            :error-messages="messageErrors"
            :counter="450"
            :label="$t('contact.label-message')"
            required
            @input="$v.form.message.$touch()"
            @blur="$v.form.message.$touch()"
            solo
            flat
        ></v-textarea>

        <v-btn class="ma-0" color="primary" @click="onSubmit">
          {{ $t('contact.btn-send') }}<v-icon class="ma-1">mdi-email-send-outline</v-icon>
        </v-btn>
      </form>
    </v-col>

    <v-col cols="12" md="4" class="text-left">
      <v-list class="transparent" three-line>
        <v-list-item>
          <v-list-item-avatar>
            <v-icon class="mr-0" color="primary" size="42">
              mdi-map-marker
            </v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="primary--text text-capitalize">
              {{ $t('general.location-txt') }}
            </v-list-item-title>
            <v-list-item-subtitle>
              <h3>{{ $t('general.location') }}</h3>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-list-item>
          <v-list-item-avatar>
            <v-icon class="mr-0" color="primary" size="42">
              mdi-email
            </v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="primary--text text-capitalize">
              {{ $t('general.email-txt') }}
            </v-list-item-title>
            <v-list-item-subtitle>
              <div class="mb-3 link">
                <a :href="'mailto:' + $t('general.email')"
                ><h3>{{ $t('general.email') }}</h3>
                </a>
              </div>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-list-item>
          <v-list-item-avatar>
            <v-icon class="mr-0" color="primary" size="42">
              mdi-phone
            </v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="primary--text text-capitalize">
              {{ $t('general.phone-txt') }}
            </v-list-item-title>
            <v-list-item-subtitle>
              <div class="mb-3 link">
                <a :href="'tel:' + $t('general.phone-call')">
                  <h3>{{ $t('general.phone-web') }}</h3>
                </a>
              </div>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-col>

    <v-row justify="space-around">
      <v-col cols="auto">
        <v-dialog
            transition="dialog-bottom-transition"
            max-width="600"
            v-model="dialog">
          <template>
            <v-card>
              <v-toolbar color="primary" dark>
                <v-toolbar-title><v-icon class="pa-1">mdi-information-outline </v-icon>{{ $t('contact.message-info') }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn
                    icon
                    dark
                    @click="dialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text>
                <div class="text-h6 pa-10">{{ $t('contact.message-info-text') }}</div>
              </v-card-text>
              <v-card-actions class="justify-end">
                <v-btn
                    class="ma-0"
                    color="primary"
                    @click="dialog = false"
                >{{ $t('contact.btn-close') }}<v-icon class="ma-0">mdi-close</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </template>
        </v-dialog>
      </v-col>
    </v-row>

    <v-col cols="12" offset-md="2" md="8">
      <core-text class="mb-0 text-center text--disabled">
        <p v-text="$t('contact.agreement')"/>
      </core-text>
    </v-col>
  </core-section>

</template>

<script>
import {validationMixin} from 'vuelidate'
import {required, maxLength, email} from 'vuelidate/lib/validators'

const querystring = require("querystring");

export default {
  mixins: [validationMixin],

  validations: {
    form: {
      email: {
        required,
        email,
      },
      message: {
        required,
        maxLength: maxLength(450),
      },
    },
  },

  data: () => ({
    dialog: false,
    form: {
      email: "",
      message: "",
    },
  }),

  computed: {
    emailErrors() {
      const errors = []
      if (!this.$v.form.email.$dirty) return errors
      !this.$v.form.email.email && errors.push(this.$t('contact.email-valid'))
      !this.$v.form.email.required && errors.push(this.$t('contact.email-required'))
      return errors
    },
    messageErrors() {
      const errors = []
      if (!this.$v.form.message.$dirty) return errors
      !this.$v.form.message.maxLength && errors.push(this.$t('contact.message-valid'))
      !this.$v.form.message.required && errors.push(this.$t('contact.message-required'))
      return errors
    },
  },

  methods: {
    onSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.axios.post('https://jankowski.app/mail.php', querystring.stringify(this.form)
        ).then(() => {
          this.dialog = true;
        })
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.link a {
  text-decoration: none;
  color: white;
}

.link a:hover {
  text-decoration: none;
  color: #ffaa00;
}
</style>
